import axios from 'axios';

const baseURL = (process.env.VUE_APP_APPOINTMENT_DEFAULTS_API_URL || '').trim();
const client = axios.create({
  baseURL,
  timeout: 10000,
  withCredentials: false,
  withXSRFToken: false,
});

// axios.create inherits global defaults, including an existing CRM login.
client.interceptors.request.use(config => {
  config.headers.delete('Authorization');
  config.headers.delete('Cookie');
  config.auth = undefined;
  config.params = undefined;
  return config;
});

let inFlight = null;

export function getAppointmentDefaultBookingNote() {
  if (!baseURL) {
    return Promise.reject(new Error('Missing VUE_APP_APPOINTMENT_DEFAULTS_API_URL'));
  }
  if (!inFlight) {
    inFlight = client.get('/appointment-defaults')
      .then(response => {
        const note = response.data && response.data.data && response.data.data.default_booking_note;
        if (typeof note !== 'string' || !note.trim()) {
          throw new Error('Invalid appointment default');
        }
        return note;
      })
      .finally(() => { inFlight = null; });
  }
  return inFlight;
}
